// src/lib/webNotification.js

import { playNotificationChime } from './notificationSound';

/**
 * Service to manage Web Notifications API & in-app alerts.
 * Standard Web Notifications API has 100% $0.00 cost, 0 server overhead,
 * and delivers real-time notifications directly to the device/desktop OS.
 */

export const getNotificationPermission = () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'unsupported';
    }
    return Notification.permission;
};

export const requestNotificationPermission = async () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'unsupported';
    }
    try {
        const permission = await Notification.requestPermission();
        return permission;
    } catch (error) {
        console.warn("Notification request permission failed:", error);
        return 'denied';
    }
};

/**
 * Sends a native browser system notification if allowed, and plays the chime.
 */
export const triggerWebNotification = ({
    title = 'Yeni Mesaj!',
    body = '',
    icon = '/logo192.png',
    tag = 'kt-chat-notification',
    onClick = null
}) => {
    // 1. Play audio chime
    playNotificationChime();

    // 2. Dispatch native OS web notification if permitted
    if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
        try {
            const options = {
                body,
                icon,
                tag,
                badge: '/logo192.png',
                vibrate: [200, 100, 200],
                renotify: true
            };

            const notification = new Notification(title, options);

            notification.onclick = (event) => {
                event.preventDefault();
                window.focus();
                if (typeof onClick === 'function') {
                    onClick();
                }
                notification.close();
            };

            return notification;
        } catch (err) {
            console.warn("Could not display native notification:", err);
        }
    }

    return null;
};
